module.exports = __webpack_public_path__ + "static/media/product.8651abf0.jpeg";